{
	"agents": [
		{
			"agentType": "mcp",
			"accountId": "712020:mock-agent-external",
			"displayName": "External session",
			"views": 110,
			"created": 5,
			"updated": 2,
			"commentCreated": 1,
			"searchPerformed": 0,
			"relatedUserAccountId": "712020:mock-human-alex",
			"relatedUserDisplayName": "Alex Rivera",
			"lastViewedAt": "2026-08-21T15:30:00.000Z"
		},
		{
			"agentType": "cursor",
			"accountId": "712020:mock-agent-cursor",
			"displayName": "Cursor session",
			"views": 104,
			"created": 4,
			"updated": 2,
			"commentCreated": 0,
			"searchPerformed": 1,
			"relatedUserAccountId": "712020:mock-human-alex",
			"relatedUserDisplayName": "Alex Rivera",
			"lastViewedAt": "2026-08-21T15:18:00.000Z"
		},
		{
			"agentType": "canva",
			"accountId": "712020:mock-agent-canva",
			"displayName": "Canva session",
			"views": 99,
			"created": 3,
			"updated": 1,
			"commentCreated": 1,
			"searchPerformed": 0,
			"relatedUserAccountId": "712020:mock-human-sam",
			"relatedUserDisplayName": "Sam Chen",
			"lastViewedAt": "2026-08-21T15:10:00.000Z"
		},
		{
			"agentType": "claude",
			"accountId": "712020:mock-agent-claude",
			"displayName": "Claude session",
			"views": 96,
			"created": 4,
			"updated": 2,
			"commentCreated": 1,
			"searchPerformed": 0,
			"relatedUserAccountId": "712020:mock-human-alex",
			"relatedUserDisplayName": "Alex Rivera",
			"lastViewedAt": "2026-08-21T15:04:00.000Z"
		},
		{
			"agentType": "codex",
			"accountId": "712020:mock-agent-codex",
			"displayName": "Codex session",
			"views": 88,
			"created": 3,
			"updated": 1,
			"commentCreated": 0,
			"searchPerformed": 0,
			"relatedUserAccountId": "712020:mock-human-alex",
			"relatedUserDisplayName": "Alex Rivera",
			"lastViewedAt": "2026-08-21T14:50:00.000Z"
		},
		{
			"agentType": "rovo_chat",
			"accountId": "712020:mock-agent-rovo",
			"displayName": "Rovo session",
			"views": 81,
			"created": 2,
			"updated": 2,
			"commentCreated": 0,
			"searchPerformed": 1,
			"relatedUserAccountId": "712020:mock-human-sam",
			"relatedUserDisplayName": "Sam Chen",
			"lastViewedAt": "2026-08-21T14:20:00.000Z"
		}
	]
}
